import React, { useState } from "react";
import style from "./style.module.css";
import formatUrl from "utils/FormatUrl";
import getAnnoncesStaticPathsQuartier from "pagesHelpers/AnnoncesStaticPaths/getAnnoncesStaticPathsQuartier.mjs";
import { norm } from "../ListingsRouterUrlHelper";
import { pluralOf } from "pagesHelpers/ListingPagesHepler/HeadSeoHelper";

const links = [
  {
    title: "hello links (1)",
    linkTo: "/",
  },
  {
    title: "hello links (2)",
    linkTo: "/",
  },
  {
    title: "hello links (3)",
    linkTo: "/",
  },
  {
    title: "hello links (4)",
    linkTo: "/",
  },
  {
    title: "hello links (5)",
    linkTo: "/",
  },
  {
    title: "hello links (6)",
    linkTo: "/",
  },
  {
    title: "hello links (7)",
    linkTo: "/",
  },
  {
    title: "hello links (8)",
    linkTo: "/",
  },
  {
    title: "hello links (9)",
    linkTo: "/",
  },
];

function getRandomNumber(min, max) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function index({
  t,
  lang,
  searchPayload,
  linksQuartier,
}: {
  t: any;
  searchPayload: any;
  lang: string;
  linksQuartier: any;
}) {
  const [showLinks, setShowLinks] = useState(false);
  return (
    <div className={style.linksCon}>
      <div className={style.linksTitles}>
        {linksQuartier?.map((slug, idx) => {
          return (
            <>
              <a
                key={idx}
                href={formatUrl(
                  `/${
                    searchPayload.transaction_type == "Vente"
                      ? "acheter"
                      : "louer"
                  }/${`immo-${norm(
                    slug.province ? slug.province : searchPayload.province
                  )}`}/${`${
                    searchPayload.transaction_type == "Location"
                      ? "location"
                      : "vente"
                  }-${norm(
                    pluralOf(slug.type ? slug.type : searchPayload.type)
                  )}`}${slug.quartier ? `/${norm(slug.quartier)}` : ""}`,
                  lang
                )}
                className={`${
                  !showLinks && idx > 3 ? style.linkHide : style.link
                } ${searchPayload.province ? "" : style.flex_two}`}
              >
                {slug.quartier
                  ? slug.quartier
                  : `${t(pluralOf(slug.type))} ${t("à")} ${
                      searchPayload.transaction_type == "Location"
                        ? t("louer")
                        : t("vendre")
                    } ${t("à")} ${t(
                      slug.province
                        .replace("Nouaceur", "Bouskoura et Dar Bouazza")
                        .replace("-Ida -Ou-Tanane", "")
                    )}`}
                {" ("}
                {slug.count}
                {")"}
              </a>
            </>
          );
        })}
      </div>
      {linksQuartier.length > 4 ? (
        <div
          className={style.voirPlusCon}
          onClick={() => {
            setShowLinks(!showLinks);
          }}
        >
          <span className={style.title}>
            {showLinks ? t("Voir moins") : t("Voir plus")}
          </span>
          <span className={showLinks ? style.iconMoin : style.iconPlus}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
            >
              <path
                d="M12.6663 6L7.99967 10.6667L3.33301 6"
                stroke="#4609F0"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </span>
        </div>
      ) : null}
    </div>
  );
}

export default index;
